import styled from 'styled-components';

export default styled.div`
  position: relative;
  left: 1.8rem;
  height: 0.8rem;
  width: 0.8rem;
  border-radius: 50%;
  border: 1px solid #B5C0C4;
  background: #FFFFFF;
  ;
`;
